import { ruleTypes } from './ruleTypes';
import _ from 'lodash';

export default class RuleModel {
  constructor(type) {
    if (!ruleTypes[type]) {
      throw Error('Rule Type not found');
    }
    this.type = type;
    this.rule = _.cloneDeep(ruleTypes[type]);
    this.template_id = null;
  }

  getRule() {
    return this.rule;
  }

  setRuleData(rule, mode) {
    // Components that exists in all rules
    this.rule.components.name.value = mode === 'clone' ? `${rule.name} (Copy)` : rule.name;
    this.rule.components.groups.value = rule.group.map((group) => ({ value: group, label: group }));
    this.rule.components.campaigns.value = rule.campaign_ids;
    if (this.hasComponent('applyToCountryBids')) {
      this.rule.components.applyToCountryBids.value = rule.applyToCountryBids;
    }
    this.rule.components.conditions.value = rule.query.map((item) => {
      const _item = JSON.parse(JSON.stringify(item));
      const key = Object.keys(_item)[0];
      const value = _item[key];
      // Custom Conversion To field
      if (value.to && value.tracker_account_id_2 && value.tracker_account_id_2 !== 1) {
        value.to = `${value.to}::${value.tracker_account_id_2}`;
        delete value.tracker_account_id_2;
      }
      // Custom Conversion trick
      if (value.tracker_account_id && value.tracker_account_id !== 1) {
        _item[`${key}::${value.tracker_account_id}`] = value;
        delete _item[key];
      }
      return _item;
    });
    // if (rule.hour_of_day) this.rule.components.conditions.value.push({ hour_of_day: { condition: '', value: rule.hour_of_day } })
    if (rule.hour_of_day_new) this.rule.components.conditions.value.push({ hour_of_day: { condition: '', value: { timezone: rule.hour_of_day_new.timezone, scheduler: rule.hour_of_day_new.time_matrix } } });
    this.rule.components.alert.value = rule.alert;

    // Optional components
    if (this.hasComponent('interval')) {
      this.rule.components.interval.value.input = rule.stats_interval || '';
      this.rule.components.interval.value.interval_exclude = rule.stats_interval_exclude;
    }
    if (this.hasComponent('rotation')) this.rule.components.rotation.value = rule.rotation;

    if (this.hasComponent('campaign_action')) this.rule.components.campaign_action.value = rule.day_parting;

    if (this.hasComponent('bid')) {
      if (rule.change_bid) this.rule.components.bid.value = rule.change_bid;
      if (rule.change_bid_cpc) this.rule.components.bid.value = rule.change_bid_cpc;
      if (rule.change_bid_cpm) this.rule.components.bid.value = rule.change_bid_cpm;
    }
    if (this.hasComponent('budget')) if (rule.change_budget) this.rule.components.budget.value = rule.change_budget;

    if (this.hasComponent('flags')) {
      if (rule.flags) {
        Object.entries(rule.flags, ([key, value]) => {
          const item = {};
          item[key] = value;
          this.rule.components.flags.value.push(item);
        });
      }
    }

    // if (rule.template_id) this.template_id = rule.template_id
  }

  getApiForm(rulePayload) {
    const form = {};
    const conditions = [];
    // eslint-disable-next-line camelcase
    let hour_of_day;
    const countryBidValidTS = this.rule.components.campaigns.value.map((campaign) => campaign.ts_type);

    // Components that exists in all rules
    form.level = this.rule.level;
    form.rule_action = this.rule.rule_action;
    form.status = typeof rulePayload.status !== 'undefined' ? rulePayload.status : true;
    form.name = this.rule.components.name.value;
    form.group = this.rule.components.groups.value.map((group) => group.value);
    form.campaign_ids = this.rule.components.campaigns.value.map((campaign) => campaign.id);
    form.alert = this.rule.components.alert.value;

    // Prepare rule conditions dividing hour of day and the other conditions
    this.rule.components.conditions.value.forEach((item) => {
      if (item.hour_of_day) {
        // eslint-disable-next-line camelcase
        hour_of_day = {};
        hour_of_day.timezone = item.hour_of_day.value.timezone;
        hour_of_day.time_matrix = item.hour_of_day.value.scheduler;
        // hour_of_day.days = item.hour_of_day.value.days
        // hour_of_day.hours = item.hour_of_day.value.hours
      } else {
        // Custom Conversion trick With To fields
        const key = Object.keys(item)[0];
        const explodeKey = key.split('::');
        const value = JSON.parse(JSON.stringify(item[key]));
        const explodeToKey = value.to.split('::');

        if (explodeKey.length > 1) {
          value.tracker_account_id = Number(explodeKey[1]);
        }

        if (explodeToKey.length > 1) {
          // eslint-disable-next-line prefer-destructuring
          value.to = explodeToKey[0];
          value.tracker_account_id_2 = Number(explodeToKey[1]);
        }

        const newItem = {};
        newItem[explodeKey[0]] = value;
        conditions.push(newItem);
      }
    });
    if (conditions.length) form.query = conditions;
    // eslint-disable-next-line camelcase
    if (hour_of_day) form.hour_of_day_new = hour_of_day;

    // Optional components
    if (this.hasComponent('interval')) {
      form.stats_interval = this.rule.components.interval.value.input;
      form.stats_interval_exclude = this.rule.components.interval.value.interval_exclude;
    }
    if (this.hasComponent('rotation')) form.rotation = this.rule.components.rotation.value;

    if (this.hasComponent('campaign_action')) form.day_parting = this.rule.components.campaign_action.value;

    if (this.hasComponent('applyToCountryBids')) form.applyToCountryBids = this.rule.components.applyToCountryBids.value.filter((item) => countryBidValidTS.includes(item));

    if (this.hasComponent('bid')) {
      form[this.rule.rule_action] = this.rule.components.bid.value;
      if (!this.rule.components.bid.value.to) { delete form[this.rule.rule_action].to; }
    }
    if (this.hasComponent('budget')) {
      form.change_budget = this.rule.components.budget.value;
      if (!this.rule.components.budget.value.to) {
        delete form.change_budget.to;
      }
    }

    if (this.hasComponent('flags')) {
      form.flags = {};
      this.rule.components.flags.value.forEach((item) => {
        const key = Object.keys(item)[0];
        form.flags[key] = item[key];
      });
    }

    if (this.template_id) form.template_id = this.template_id;

    return form;
  }

  // return if the component has the attribute
  hasComponent(attribute) {
    return (this.rule.components[attribute] && this.rule.components[attribute].active);
  }

  getActiveComponentskey() {
    const keys = [];
    Object.entries(this.rule.components).forEach(([key, component]) => {
      if (component.active) keys.push(key);
    });
    return keys;
  }
}
